import { Component, ElementRef, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs/Rx';
import { ConfigService } from '../../config.service';
import { AppService, IApp } from '../api/app.service';
import { NotificationService } from '../api/notification.service';
import { AppsInstalledChangeService } from '../appsInstalled-change.service';
import { AuthService } from '../auth.service';

@Component({
  selector: 'ri-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css'],
})
export class MenuComponent implements OnInit  {
  apps: IApp[] = [];
  menuHeight: number;
  itemHeight: number;
  showSubmenu = false;
  companyLogoUrl = ConfigService.app.companyLogoUrl;

  private appInstalledSubscription: Subscription;
  get limitTo(): number {
    let limit = Math.floor( this.menuHeight / this.itemHeight );
    if (limit > 8) {
      limit = limit + 3;
    }
    return limit < 0 ? 0 : limit;

  }
  get menu(): any[] {
    return this.apps.filter( (v, k) => k < this.limitTo )
  }
  get submenu(): any[] {
    return this.apps.filter( (v, k) => k >= this.limitTo );
  }

  constructor(
    private _sanitizer: DomSanitizer,
    private element: ElementRef,
    private _router: Router,
    private translate: TranslateService,
    private notificationService: NotificationService,
    private authService: AuthService,
    private appsInstalledChangeService: AppsInstalledChangeService,
    private appService: AppService
  ) { }

  ngOnInit() {
    if (this.authService.user && this.authService.user && this.authService.user.pinnedAppIds) {
      this.getInstalledApps();
    }

    this.appInstalledSubscription = this.appsInstalledChangeService.appInstalledObservable.subscribe(value => {
      if (value) {
        this.getInstalledApps();
      }
    });

    setTimeout( () => this.onResize() );
  }

  onResize(event?): void {
    this.menuHeight = this.element.nativeElement.parentElement.offsetHeight - this.element.nativeElement.offsetTop;
    this.itemHeight = this.element.nativeElement.firstElementChild.children[0].clientHeight || 46;
  }

  toggleSubmenu(): void {
    this.showSubmenu = !this.showSubmenu;
  }

  private getInstalledApps() {
    this.appService.getInstalledApps().subscribe(
      response => {
        this.apps = response;
      }, (err) => {
        this.translate.get('ERROR_MESSAGE').subscribe((text: string) => {
          this.notificationService.showNotification(text);
        });
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/core/menu/menu.component.ts